module.exports = __webpack_public_path__ + "static/media/Ecologie_PictoCdlT.023b828e.png";